var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 51,
    viewBox: "0 0 58 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 51,
    rx: 8,
    fill: "#8B659C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 29.5L32.7216 26L26.6666 22.5V29.5ZM40.1533 20.365C40.305 20.9133 40.41 21.6483 40.48 22.5817C40.5616 23.515 40.5966 24.32 40.5966 25.02L40.6666 26C40.6666 28.555 40.48 30.4333 40.1533 31.635C39.8616 32.685 39.185 33.3617 38.135 33.6533C37.5866 33.805 36.5833 33.91 35.0433 33.98C33.5266 34.0617 32.1383 34.0967 30.855 34.0967L29 34.1667C24.1116 34.1667 21.0666 33.98 19.865 33.6533C18.815 33.3617 18.1383 32.685 17.8466 31.635C17.695 31.0867 17.59 30.3517 17.52 29.4183C17.4383 28.485 17.4033 27.68 17.4033 26.98L17.3333 26C17.3333 23.445 17.52 21.5667 17.8466 20.365C18.1383 19.315 18.815 18.6383 19.865 18.3467C20.4133 18.195 21.4166 18.09 22.9566 18.02C24.4733 17.9383 25.8616 17.9033 27.145 17.9033L29 17.8333C33.8883 17.8333 36.9333 18.02 38.135 18.3467C39.185 18.6383 39.8616 19.315 40.1533 20.365Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube_icon.20c800ad1bd2bd7ba5bb242e9d354212.svg";
export { ForwardRef as ReactComponent };